import tenantConfig from '../../../../layers/core/tenant.config';

export default {
  legacy: false,
  fallbackLocale: tenantConfig.fallbackLocale || tenantConfig.defaultLocale,
};
